import { Quill } from 'react-quill'

import { Tooltip } from '../Tooltip'

import { embedCode } from 'shared/quill/utils'

export class SocialEmbedder {
  private editor: any

  constructor(quill: typeof Quill) {
    this.editor = quill

    this.editor.getModule('toolbar').addHandler('embed', this.setTooltip)
  }

  private setTooltip = (): void => {
    const tooltip = new Tooltip(this.editor)

    if (!tooltip.textbox) return

    tooltip.edit('embed')
    tooltip.textbox.placeholder = 'Embed code or URL'
    tooltip.save$.subscribe(this.insertEmbedCode)
  }

  private insertEmbedCode = async (value: string | unknown): Promise<void> => {
    if (!value) return

    const code = await embedCode(value as string)
    const range = this.editor.getSelection(true)

    this.editor.insertEmbed(range.index, 'social', code, 'user')
    this.editor.setSelection(range.index + 1, 'silent')
  }
}
